import { render, staticRenderFns } from "./Inventories.vue?vue&type=template&id=2334640d&scoped=true"
import script from "./Inventories.vue?vue&type=script&lang=js"
export * from "./Inventories.vue?vue&type=script&lang=js"
import style0 from "./Inventories.vue?vue&type=style&index=0&id=2334640d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334640d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2334640d')) {
      api.createRecord('2334640d', component.options)
    } else {
      api.reload('2334640d', component.options)
    }
    module.hot.accept("./Inventories.vue?vue&type=template&id=2334640d&scoped=true", function () {
      api.rerender('2334640d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/interestProfile/components/Inventories.vue"
export default component.exports